module.exports = __webpack_public_path__ + "static/media/imagemLogistica.0440753d.svg";